import React, { useEffect, useState, useRef } from "react";
import { FaUserCircle, FaPlaneDeparture } from "react-icons/fa";
import { Link, Routes, Route } from "react-router-dom";
import { GiExitDoor } from "react-icons/gi";
import { useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import CreateCandidateAccount from "../Components/CreateCandidateAccount";
import ViewCandidateDetails from "./ViewCandidateDetails";
import ViewCandidateAccount from "./ViewCandidateAccount";
import CreateCandidateExitsAccount from "../ExitsUsers/CreateCandidateExitsAccount";
import UploadEmployeeExitsDocument from "../ExitsUsers/UploadEmployeeExitsDocument";
import DisplayDocuments from "../ExitsUsers/DisplayDocuments";
import Settings from "./Settings";
import global from ".././assets/logo6.png";

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [cookies,setCookie, removeCookie] = useCookies(["authToken", "userName", "role", "team"]);
  const navigate = useNavigate();
  const location = useLocation();
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileMenuRef = useRef(null);
  const [accessTabs, setAccessTabs] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null); // State for dropdowns

  const toggleProfileMenu = () => setIsProfileOpen(!isProfileOpen);
  
  // Toggle Dropdowns
  const toggleDropdown = (tabName) => {
    setOpenDropdown(openDropdown === tabName ? null : tabName);
  };

  useEffect(() => {
    if (!cookies.authToken) {
      navigate("/");
    }
  }, [cookies.authToken, navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    // alert("Logout Successfully");
    removeCookie("authToken", { path: "/" });
    removeCookie("userName", { path: "/" });
    removeCookie("role", { path: "/" });
    removeCookie("team", { path: "/" });
    navigate("/");
    setTimeout(() => {
      window.location.reload();
    }, 100); // small delay to ensure navigate is processed
  };

  // Fetch Access Tabs Based on Role
  useEffect(() => {
    const fetchAccessTabs = async () => {
      try {
        const response = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/access/${cookies.role}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setAccessTabs(data.accessTabs || []);
      } catch (error) {
        console.error("Error fetching access tabs:", error);
      }
    };

    if (cookies.role) {
      fetchAccessTabs();
    }
  }, [cookies.role]);

  // Define available navigation tabs
  const availableTabs =
  cookies.role === "67f7d873fa852258bf9a2112"
    ? [
        {
          name: "OnBoarding Deck",
          icon: <FaPlaneDeparture className="mx-2" />,
          subOptions: [
            { name: "View Candidate Details", path: "/dashboard/view-candidate-details" },
          ],
        },
      ]
    : [
        {
          name: "OnBoarding Deck",
          icon: <FaPlaneDeparture className="mx-2" />,
          subOptions: [
            { name: "Create Candidate Account", path: "/dashboard/create-candidate-account" },
            { name: "View Candidate Details", path: "/dashboard/view-candidate-details" },
          ],
        },
        {
          name: "Employee Exit Deck",
          icon: <GiExitDoor className="mx-2" />,
          subOptions: [
            { name: "Create Employee Exit Account", path: "/dashboard/CreateCandidateExitsAccount" },
            { name: "Upload Documents", path: "/dashboard/Upload-Employee-Exits-Document" },
          ],
        },
      ];

       
  
  return ( 
    <div className="h-screen flex">
      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 bg-primary-blueCustomColor text-white ${isSidebarOpen ? "w-52" : "w-20"} transform transition-all duration-300 ease-in-out z-50`}>
        <img src={global} className="  p-0" alt="Logo" />
        <div className="p-4 flex items-center justify-between">
          <h1 className={`text-xl font-bold font-serif hover:text-blue-50 ${isSidebarOpen ? "block" : "hidden"}`}>HR Portal</h1>
          <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="text-gray-400">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>

        {/* Sidebar Navigation */}
        <nav className="mt-4">
          <ul>
            {availableTabs
              ?.filter(tab => accessTabs?.includes(tab?.name)) // Show only assigned tabs
              .map(tab => (
                <li key={tab?.name} className=" px-2 text-sm rounded flex flex-col">
                  <button
                    className="flex items-center w-full justify-between hover:bg-gray-700"
                    onClick={() => toggleDropdown(tab?.name)}
                  >
                    <div className="flex items-center py-2 rounded-lg">
                      {tab?.icon}
                      {isSidebarOpen && <span>{tab?.name}</span>}
                    </div>
                    {isSidebarOpen && (
                      openDropdown === tab?.name ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />
                    )}
                  </button>
                  
                  {/* Sub-options */}
                  {openDropdown === tab?.name && (
                    <ul className="ml-2 mt-2 space-y-2">
                      {tab.subOptions?.map(sub => (
                        <li key={sub?.name} className=" text-sm">
                          <Link to={sub?.path} className="block pl-4 rounded py-2 text-xs hover:bg-gray-600">
                            {sub?.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
          </ul>
        </nav>

        {/* Logout Button */}
        <div className="absolute bottom-0 w-full border  my-2 border-black">
          <button onClick={handleLogout} className="text-white rounded py-2 px-4 w-full hover:bg-red-600">
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className={`flex-1  transition-all duration-300 ease-in-out ${isSidebarOpen ? "ml-52" : "ml-20"}`}>
        <main className="flex-1 bg-white">
          <div className="flex justify-between  bg-primary-blueCustomColor  ">
                   <div className="p-2   text-lg text-white font-bold mx-10">Welcome, {cookies.userName || 'User'}</div>
                   <div className="p-1.5 text-sm font-medium">
           
          </div> 
          {cookies.role === "67eecfde4e264c0e1d09876f" && (
  <div className="relative mr-2 mt-2">
    <button onClick={toggleProfileMenu} className="text-white focus:outline-none">
      <FaUserCircle className="text-3xl" />
    </button>
    {isProfileOpen && (
      <div ref={profileMenuRef} className="absolute right-0 mt-2 w-40 bg-gray-500 border rounded shadow-md z-10">
        {/* <Link to="/#" className="block px-4 py-2 text-sm hover:bg-gray-200 border-b">
          View Profile
        </Link> */}
        <Link to="/SignUpWithHR" className="block px-4 py-2 text-sm  text-black font-semibold  hover:bg-gray-200  border-b">
          Add User
        </Link>
       
        <Link to="/Teams" className="block px-4 py-2 text-sm  text-black font-semibold hover:bg-gray-200 border-b">
          Add Team
        </Link>
        <Link to="/role" className="block px-4 py-2 text-sm  text-black font-semibold hover:bg-gray-200 border-b">
          Add Role
        </Link>
        <Link to="/Access" className="block px-4 py-2 text-sm  text-black font-semibold hover:bg-gray-200 border-b">
          Give Access
        </Link>
        <button onClick={handleLogout} className="w-full text-left  text-black font-semibold px-4 py-2 text-sm hover:bg-gray-200 border-b">
          Logout
        </button>
      </div>
    )}
  </div>
)}

                   </div>

          {/* Routes */}
          <Routes>
            <Route path="create-candidate-account" element={<CreateCandidateAccount />} />
            <Route path="view-candidate-details" element={<ViewCandidateDetails />} />
            <Route path="view-candidate-account" element={<ViewCandidateAccount />} />
            <Route path="CreateCandidateExitsAccount" element={<CreateCandidateExitsAccount />} />
            <Route path="Upload-Employee-Exits-Document" element={<UploadEmployeeExitsDocument />} />
            <Route path="DisplayDocuments" element={<DisplayDocuments />} />
            <Route path="Settings" element={<Settings />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
